/* eslint-disable */
const localization = {
    // This is the array of lexemes found in the app
    lexemes: [
      "App Store से डाउनलोड करें",
      "असल ज़िंदगी में आसपास के समूहों से मिलें",
      "Hives में अपने नये क्रू के साथ कनेक्ट करें।",
      "अपने टाइप के लोग खोजें",
      "आपका जुनून जो भी हो, आपके लिए एक Hive है!",
      "अपने वास्तविक रूप में होने के लिए एक सुरक्षित स्थान",
      "छिपे हुए या खोजे जा सकने वाले Hives में से चुनें।",
      "शुरू करें",
      "आपका जुनून जो भी हो, आपके लिए एक Hive है",
      "Bumble BFF पर Hives में लोगों के एक नये समूह को जानें",
      "आपको Hives में आमंत्रित किया गया है",
      "Bumble BFF के नये फीचर, Hives पर स्थानीय लोगों के नये ग्रुप्स से मिलें। आज ही Bumble ऐप पर अपनी BFF प्रोफ़ाइल बनाएं।",
      "इसे Google Play से प्राप्त करें",
      "कुकीज़ प्रबंधित करें",
      "Gender Pay Gap",
      "Modern Slavery Statement",
      "Terms and Conditions",
      "About",
      "Life"
],

    // These are the common words found in the lexemes of the app
    common: {
      "day": {
            "plural": [
                  "दिन",
                  "दिनों"
            ],
            "singular": [
                  "दिन",
                  "दिन"
            ]
      },
      "hour": {
            "plural": [
                  "घंटे",
                  "घंटे"
            ],
            "singular": [
                  "घंटे",
                  "घंटे"
            ]
      },
      "minute": {
            "plural": [
                  "मिनट",
                  "मिनटों"
            ],
            "singular": [
                  "मिनट",
                  "मिनट"
            ]
      },
      "month": {
            "plural": [
                  "महीने",
                  "महीनों"
            ],
            "singular": [
                  "महीना",
                  "महीना"
            ]
      },
      "second": {
            "plural": [
                  "सेकंड",
                  "सेकंड"
            ],
            "singular": [
                  "सेकंड",
                  "सेकंड"
            ]
      },
      "year": {
            "plural": [
                  "साल",
                  "सालों"
            ],
            "singular": [
                  "साल",
                  "साल"
            ]
      }
}
};

// In dev mode we extend lexemes to include the indexMap as well, in production it remains as an array
if (__DEV__) {
    // This is a map of lexeme ids to their index in the array, it's only needed during development
    const indexMap = require('./index-map').default;

    localization.indexMap = indexMap;

    Object.entries(localization.indexMap).forEach(([indexKey, indexValue]) => {
        localization.lexemes[indexKey] = localization.lexemes[indexValue];
    });
}

export default localization;
